import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("circle", {
  cx: 33,
  cy: 29,
  r: 26,
  fill: "#C1E5FF"
});

var _ref2 =
/*#__PURE__*/
___EmotionJSX("circle", {
  cx: 26,
  cy: 26,
  r: 26,
  fill: "#73C4FF"
});

var _ref3 =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M32.768 30.19c0 1.335-.511 2.47-1.534 3.406-1.023.919-2.522 1.43-4.498 1.534v2.99h-1.3v-2.964a12.23 12.23 0 0 1-3.588-.728c-1.11-.433-1.985-.98-2.626-1.638l.754-1.482c.607.59 1.395 1.083 2.366 1.482a9.92 9.92 0 0 0 3.094.702v-6.838c-1.196-.295-2.193-.607-2.99-.936a5.356 5.356 0 0 1-2.002-1.482c-.52-.659-.78-1.525-.78-2.6 0-1.335.485-2.453 1.456-3.354.97-.919 2.41-1.456 4.316-1.612v-2.99h1.3v2.964c.988.035 1.941.2 2.86.494.936.277 1.742.65 2.418 1.118l-.65 1.534a9.992 9.992 0 0 0-2.262-1.066 8.884 8.884 0 0 0-2.366-.442v6.89c1.283.312 2.331.633 3.146.962.815.312 1.5.797 2.054 1.456.555.659.832 1.525.832 2.6zm-11.206-8.606c0 .901.33 1.586.988 2.054.676.468 1.638.867 2.886 1.196v-6.5c-1.283.104-2.253.46-2.912 1.066-.641.59-.962 1.317-.962 2.184zm5.174 11.908c1.37-.104 2.4-.442 3.094-1.014.693-.572 1.04-1.3 1.04-2.184 0-.936-.355-1.638-1.066-2.106-.71-.468-1.733-.867-3.068-1.196v6.5z",
  fill: "#fff"
});

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    width: 59,
    height: 55,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/faq-cost.c86a7a20.svg";
export { SvgComponent as ReactComponent };